export interface ParsedPlaceAddress {
  formattedAddress: string;
  state: string;
  street: string;
  street_number: string;
  postal_code: string;
  city: string;
}

export const EMPTY_PARSED_PLACE_ADDRESS: ParsedPlaceAddress = {
  formattedAddress: '',
  state: '',
  street: '',
  street_number: '',
  postal_code: '',
  city: '',
};

type AddressComponent = {
  long_name: string;
  short_name: string;
  types: string[];
};

/** Parse Google address components into backend address fields. */
export function parseAddressComponents(
  formattedAddress: string,
  components: AddressComponent[],
): ParsedPlaceAddress {
  if (!components.length) {
    return { ...EMPTY_PARSED_PLACE_ADDRESS, formattedAddress };
  }

  let streetNumber = '';
  let route = '';
  let locality = '';
  let administrativeArea1 = '';
  let postalCode = '';

  for (const component of components) {
    for (const type of component.types) {
      switch (type) {
        case 'street_number':
          streetNumber = component.long_name;
          break;
        case 'route':
          route = component.long_name;
          break;
        case 'locality':
          locality = component.long_name;
          break;
        case 'administrative_area_level_1':
          administrativeArea1 = component.short_name;
          break;
        case 'postal_code':
          postalCode = component.long_name;
          break;
        default:
          break;
      }
    }
  }

  return {
    formattedAddress,
    state: administrativeArea1,
    street: route,
    street_number: streetNumber,
    postal_code: postalCode,
    city: locality,
  };
}

/** Parse Google Places `PlaceResult` into backend address fields. */
export function parseGooglePlaceAddress(
  place: google.maps.places.PlaceResult,
): ParsedPlaceAddress {
  return parseAddressComponents(
    place.formatted_address?.trim() ?? '',
    (place.address_components ?? []) as AddressComponent[],
  );
}

export function hasCompleteParsedAddress(address: ParsedPlaceAddress): boolean {
  return Boolean(
    address.state &&
      address.street &&
      address.street_number &&
      address.postal_code &&
      address.city,
  );
}
